__turbopack_context__.v({
  "badge": "badge-module-scss-module__YTngCG__badge",
  "tag": "badge-module-scss-module__YTngCG__tag",
});
